import comp from "./ParentLoginForm";
export default comp;
